import { render, staticRenderFns } from "./VisitasContainer.vue?vue&type=template&id=61ba1026&scoped=true"
import script from "./VisitasContainer.vue?vue&type=script&lang=js"
export * from "./VisitasContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba1026",
  null
  
)

export default component.exports